export default __webpack_public_path__ + "static/drukarki_dzierzawa_gx7040-7f23346288e8e3fb54832353bb78f697.png";